// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__MRGvR","blackColor":"styles_blackColor__34y_G"};